const EVENT_NAMES = Object.freeze({
  HIDE_BUTTON: 'comply-auto:hide',
  SHOW_BUTTON: 'comply-auto:show',
});

export default EVENT_NAMES;
